import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { CalculationWithCaregiverAndFamilyData } from '../../../types/calculation';
import { CALCULATIONS_HISTORY_TABLE_COLS } from '../../../constants/tables';
import { formatDate } from '../../../helpers/utils';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import theme from '../../theme';
import Typography from '../common/Typography';
import { getCalculationResultColor } from '../../../service/calculation';
import { CareGiver } from '../../../types/caregivers';
import { Family } from '../../../types/families';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';

interface ICalculationHistoryTable {
  className?: string;
  data: CalculationWithCaregiverAndFamilyData[];
  onDownload: (calc: CalculationWithCaregiverAndFamilyData) => void;
  onLoadCalculation: (calculation: CalculationWithCaregiverAndFamilyData) => void;
  onDelete: (id: string) => void;
  loadingPdf: boolean;
} 

export default function CalculationsHistoryTable({
  data,
  className,
  loadingPdf,
  onDownload,
  onLoadCalculation,
  onDelete,
}: ICalculationHistoryTable) {
  return (
    <Table
      removeWrapper
      className={className} 
      isStriped aria-label="Famiglie">
      <TableHeader>
        {CALCULATIONS_HISTORY_TABLE_COLS.map((c, i) => (
          <TableColumn key={i}>{c}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {
          data.map((calculation, i) => (
            <TableRow key={i}>
              <TableCell>{formatDate(new Date(calculation.tsCreated))}</TableCell>
              <TableCell>{`${calculation.familyData.name} ${calculation.familyData.surname}`}</TableCell>
              <TableCell>{`${calculation.caregiverData.name} ${calculation.caregiverData.surname}`}</TableCell>
              <TableCell>
                <Typography variant='button' style={{fontWeight: 700, color: calculation ? getCalculationResultColor(calculation.result) : undefined}}>{calculation?.stringResult ?? '-------'}</Typography>
              </TableCell>
              <TableCell style={{fontWeight: 700}}>{calculation.result.toFixed(2)} %</TableCell>
              <TableCell className='max-w-20'>
                <div className="items-center">
                {
                  calculation.relativeFamilyData && calculation.relativeCaregiverData && calculation.distance && (
                    <Tooltip content="Colloquio">
                    <span 
                      onClick={() => onLoadCalculation(calculation)}
                      className="text-lg text-default-400 cursor-pointer active:opacity-50 mr-4">
                      <ReplyRoundedIcon style={{color: theme.color.primary}}/>
                    </span>
                  </Tooltip>
                  )
                 }
                  <Tooltip content="Scarica">
                    <span 
                      onClick={
                        loadingPdf
                          ? () => {}
                          : () => onDownload(calculation)
                      }
                      className="text-lg text-default-400 cursor-pointer active:opacity-50 mr-4">
                      <DownloadRoundedIcon style={{color: theme.color.primary}}/>
                    </span>
                  </Tooltip>
                  <Tooltip content="Elimina" color='danger'>
                    <span 
                      onClick={
                        loadingPdf
                          ? () => {}
                          : () => onDelete(calculation.id)
                      }
                      className="text-lg text-default-400 cursor-pointer active:opacity-50 mr-4">
                      <DeleteIcon style={{color: theme.color.error}}/>
                    </span>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))
        }
      </TableBody>
    </Table>
  )
}